import axios from "axios";
import React, { useEffect, useState } from "react";
import all_cate from '../assets/images/home/all_cate.png';

const Categories = (props) => {
    const [categories, setCategories] = useState();
    useEffect(() => {
        if (!categories) {
            axios.get("pos/categories")
              .then(resp => {
                setCategories(resp.data.data);
              });
          }

    }, []);

    return (
        <>
         <h2 className="p-2">Categories</h2>
              <div className="category_div">
                <button className={props.cateID ? "category_card" : "category_card active"} onClick={() => {
                  props.setCateID(null);
                }}>
                  <span role="img" aria-label="database" className="catIcon">
                    <img className="catIcon" src={all_cate} alt='All'
                      width="40" height="40" />
                  </span>
                  <p className="m-0">All</p>
                </button>
                {categories &&
                  (
                    categories.map((category, index) => {
                      return (
                        <button key={index} className={props.cateID === category.id ? "category_card active" : "category_card"} onClick={() => {
                            props.setCateID(category.id);
                        }}>
                          <span role="img" aria-label="database" className="catIcon">
                            <img className="catIcon" src={category.category_image_inactive ?? category.category_image_active} alt={category.category_name}
                              width="40" height="40" />
                          </span>
                          <p className="m-0" title={category.category_name}>{category.category_name}</p>
                        </button>
                      );
                    })
                  )
                }
              </div>
        </>
    );
};

export default Categories;
